import { Navigate } from 'react-router-dom';

import { FullScreenLoading } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { useGetDeepDivesQuery } from '@backrs_ui/grow-ui/src/redux/deepDive/deepDive.api';
import {
  selectIsFeatureFlagEnabled,
  FEATURE_FLAGS,
} from '@backrs_ui/grow-ui/src/redux/featureFlags/featureFlags';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';

import { DeepDivesPage } from './DeepDivesPage';
import { useAgentContext } from './DeepDivesPageContainer.agentContext';

export const DeepDivesPageContainer = () => {
  const flagValues = useAppSelector((state) => state.featureFlags.flagValues);
  const isCoachingEnabled = useAppSelector(selectIsFeatureFlagEnabled(FEATURE_FLAGS.COACHING));

  const { data: deepDives, isLoading, isError } = useGetDeepDivesQuery(undefined);

  useAgentContext(deepDives);

  if (!(FEATURE_FLAGS.COACHING in flagValues) || isLoading) {
    return <FullScreenLoading />;
  }

  if (!isCoachingEnabled || isError || !deepDives) {
    return <Navigate to={APP_ROUTE.HOME} replace />;
  }

  return <DeepDivesPage deepDives={deepDives} />;
};
